export function getContentHash(url: string, uidx: string) {
    // const partsOfUrl = url.split('/');
    // const [hash] = partsOfUrl.slice(-1);
    const contentUrl = uidx + '/' + url;

    return contentUrl;
}
